module.exports = __webpack_public_path__ + "img/calendar-exclamation.1a851173.svg";